/*
  Product page extras. See snippets/product-enhance.liquid for what each part
  does. Everything here builds on the theme's own markup and leaves it working
  underneath: the old photos stay (hidden) so theme.js can keep switching them
  per variant, and the sticky bar clicks the real Add to cart button.
*/
(function () {
  var PHONE = window.matchMedia('(max-width: 768px)');

  /* ---------- Photo slider ---------- */
  function gallery(section) {
    var root = section.closest('.shopify-section') || section.parentNode;
    var data = root.querySelector('[data-pe-images]') || document.querySelector('[data-pe-images]');
    var col = section.querySelector('.product-single__hero > .grid__item');
    if (!data || !col) return;
    var images;
    try { images = JSON.parse(data.textContent); } catch (e) { return; }
    if (!images.length) return;

    function sized(url, w) { return url.replace(/([?&])width=\d+/, '$1width=' + w); }
    function srcset(url) { return [450, 700, 900, 1200, 1600].map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', '); }

    var ratio = Math.min(Math.max(images[0].ratio || 1, 0.8), 1.5);
    var pg = document.createElement('div');
    pg.className = 'pg' + (images.length < 2 ? ' pg--single' : '');
    pg.style.setProperty('--pg-ratio', ratio);
    pg.innerHTML =
      '<div class="pg__main">' +
        '<div class="pg__track" tabindex="0" aria-label="Product photos"></div>' +
        '<button type="button" class="pg__arrow pg__arrow--prev" aria-label="Previous photo">&lsaquo;</button>' +
        '<button type="button" class="pg__arrow pg__arrow--next" aria-label="Next photo">&rsaquo;</button>' +
      '</div>' +
      '<div class="pg__thumbs"></div>' +
      '<div class="pg__dots"></div>';
    var track = pg.querySelector('.pg__track');
    var thumbs = pg.querySelector('.pg__thumbs');
    var dots = pg.querySelector('.pg__dots');
    var prev = pg.querySelector('.pg__arrow--prev');
    var next = pg.querySelector('.pg__arrow--next');

    images.forEach(function (img, i) {
      var slide = document.createElement('button');
      slide.type = 'button';
      slide.className = 'pg__slide';
      slide.setAttribute('aria-label', 'Zoom photo ' + (i + 1) + ' of ' + images.length);
      slide.innerHTML = '<img src="' + img.src + '" srcset="' + srcset(img.src) + '" sizes="(min-width: 769px) 50vw, 100vw" alt="" ' +
        (i === 0 ? 'fetchpriority="high"' : 'loading="lazy"') + ' decoding="async">';
      slide.querySelector('img').alt = img.alt || '';
      slide.addEventListener('click', function () { zoom(i); });
      track.appendChild(slide);

      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'pg__thumb';
      t.setAttribute('aria-label', 'Show photo ' + (i + 1));
      t.innerHTML = '<img src="' + img.thumb + '" alt="" loading="lazy">';
      t.addEventListener('click', function () { go(i); });
      thumbs.appendChild(t);

      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'pg__dot';
      d.setAttribute('aria-label', 'Show photo ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dots.appendChild(d);
    });

    col.insertBefore(pg, col.firstChild);
    col.classList.add('pg-ready');

    var current = 0;
    function go(i, instant) {
      i = Math.max(0, Math.min(images.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      current = i;
      [thumbs, dots].forEach(function (list) {
        Array.prototype.forEach.call(list.children, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
      var t = thumbs.children[i];
      if (t && thumbs.scrollWidth > thumbs.clientWidth) thumbs.scrollTo({ left: t.offsetLeft - thumbs.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      prev.disabled = i === 0;
      next.disabled = i === images.length - 1;
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) mark(i);
      });
    }, { passive: true });
    prev.addEventListener('click', function () { go(current - 1); });
    next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });
    window.addEventListener('resize', function () { go(current, true); });
    mark(0);

    function zoom(i) {
      var $ = window.jQuery;
      if ($ && $.magnificPopup) {
        $.magnificPopup.open({
          items: images.map(function (img) { return { src: img.zoom }; }),
          type: 'image',
          mainClass: 'mfp-fade',
          closeOnContentClick: true,
          closeBtnInside: false,
          removalDelay: 300,
          gallery: {
            enabled: true,
            navigateByImgClick: false,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>'
          }
        }, i);
      } else {
        window.open(images[i].zoom, '_blank');
      }
    }

    // Follow variant photos: theme.js un-hides the old wrapper for the picked
    // variant's photo; move the slider to the same photo.
    var ids = images.map(function (img) { return String(img.id); });
    var old = col.querySelectorAll('.product-single__image-wrapper[id^="ProductImageWrapper-"]');
    if (old.length && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        for (var k = 0; k < old.length; k++) {
          if (!old[k].classList.contains('hide')) {
            var idx = ids.indexOf(old[k].id.replace('ProductImageWrapper-', ''));
            if (idx > -1 && idx !== current) go(idx);
            return;
          }
        }
      });
      Array.prototype.forEach.call(old, function (w) { mo.observe(w, { attributes: true, attributeFilter: ['class'] }); });
      // Start on the photo the page opened with (e.g. ?variant=).
      for (var k = 0; k < old.length; k++) {
        if (!old[k].classList.contains('hide')) {
          var start = ids.indexOf(old[k].id.replace('ProductImageWrapper-', ''));
          if (start > 0) requestAnimationFrame(function () { go(start, true); });
          break;
        }
      }
    }
  }

  /* ---------- Phones: sticky Add to cart ---------- */
  function stickyBar(section) {
    var real = section.querySelector('#AddToCart');
    if (!real || real.offsetParent === null) return; // hidden (call for price)
    var label = section.querySelector('#AddToCartText') || real;
    var price = section.querySelector('#ProductPrice');
    var title = section.querySelector('.product-single__title');

    var bar = document.createElement('div');
    bar.className = 'pe-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="pe-bar__info"><span class="pe-bar__title"></span><span class="pe-bar__price"></span></div>' +
      '<button type="button" class="pe-bar__btn" tabindex="-1"></button>';
    var btn = bar.querySelector('.pe-bar__btn');
    bar.querySelector('.pe-bar__title').textContent = title ? title.textContent.trim() : '';
    document.body.appendChild(bar);

    function sync() {
      btn.textContent = label.textContent.trim();
      btn.disabled = real.disabled;
      if (price) bar.querySelector('.pe-bar__price').textContent = price.textContent.trim();
    }
    sync();
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(label, { childList: true, characterData: true, subtree: true });
      mo.observe(real, { attributes: true, attributeFilter: ['disabled', 'class'] });
      if (price) mo.observe(price, { childList: true, characterData: true, subtree: true });
    }
    btn.addEventListener('click', function () { if (!real.disabled) real.click(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Only once the real button has scrolled up out of view.
        var on = !e.isIntersecting && e.boundingClientRect.top < 0 && PHONE.matches;
        bar.classList.toggle('is-on', on);
      }).observe(real);
    }
  }

  /* ---------- Phones: description sections ---------- */
  function accordions(section) {
    if (!PHONE.matches) return;
    var desc = section.querySelector('.product-description');
    if (!desc || desc.offsetParent === null || desc.dataset.peDone) return;
    desc.dataset.peDone = '1';
    var nodes = Array.prototype.slice.call(desc.childNodes);
    // The theme's "Need more than what's available?" note (and the lines
    // around it) stays visible below the sections.
    var tail = [];
    for (var k = 0; k < nodes.length; k++) {
      if (nodes[k].nodeType === 1 && /Need more than what/.test(nodes[k].textContent)) {
        var from = k;
        while (from > 0 && (nodes[from - 1].nodeType !== 1 || nodes[from - 1].tagName === 'HR')) {
          from--;
          if (nodes[from].nodeType === 1) break;
        }
        tail = nodes.slice(from);
        nodes = nodes.slice(0, from);
        break;
      }
    }
    var groups = [{ title: 'Description', nodes: [] }];
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && /^H[2-6]$/.test(n.tagName) && n.textContent.trim()) {
        groups.push({ title: n.textContent.trim(), nodes: [] });
      } else {
        groups[groups.length - 1].nodes.push(n);
      }
    });
    if (!groups[0].nodes.some(function (n) { return n.nodeType === 1 || (n.textContent || '').trim(); })) groups.shift();
    desc.innerHTML = '';
    groups.forEach(function (g, i) {
      var d = document.createElement('details');
      d.className = 'pe-acc';
      if (i === 0) d.open = true;
      var s = document.createElement('summary');
      s.textContent = g.title;
      var body = document.createElement('div');
      body.className = 'pe-acc__body';
      g.nodes.forEach(function (n) { body.appendChild(n); });
      d.appendChild(s);
      d.appendChild(body);
      desc.appendChild(d);
    });
    tail.forEach(function (n) { desc.appendChild(n); });
  }

  function init() {
    var sections = document.querySelectorAll('[data-section-type="product-template"]');
    Array.prototype.forEach.call(sections, function (section) {
      gallery(section);
      stickyBar(section);
      accordions(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
